module.exports = __webpack_public_path__ + "static/media/icon-warning.fa8a34a5.svg";